import { useWebTrafficKPIs } from '@/api/webTraffic';
import { usePageFilterContext } from '@/components/page';
import { TrafficKPIs } from '@/features/TrafficKPIs';

const PaidSearchOverviewKPIMetrics = () => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();

  const { webTrafficKPIs, isLoading, error } = useWebTrafficKPIs(startDate, endDate, audience);

  return <TrafficKPIs trafficKPIData={webTrafficKPIs} isLoading={isLoading} error={error} />;
};

export default PaidSearchOverviewKPIMetrics;
